import React from 'react';
import styles from './App.module.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Hero from './Componets/Hero/Hero';
import Pricing from './Componets/Pricing/Pricing';
import Home from './Componets/Home';
import Navbar from './Componets/Navbar/Navbar';
import AudioController from './AudioController/AudioController';
import MusicAdmin from './MusicShare/MusicAdmin';
import MusicViewer from './MusicShare/MusicViewer';
import CRMApp from './CRM/CRMApp';
import Login from './CRM/pages/Auth/Login';
import Register from './CRM/pages/Auth/Register';
import UserPortal from './CRM/pages/UserPortal/UserPortal';
import AuthRoute from './CRM/components/AuthRoute';
import InvoiceGenerator from './INV/InvoiceGenerator';
import PersonalExpenses from './CRM/pages/PersonalExpenses/PersonalExpenses';
import Footer from './Componets/Footer/Footer';

const App = () => {
  const location = useLocation();
  const isPrivateApp = location.pathname.startsWith('/crm') || 
                       location.pathname.startsWith('/login') || 
                       location.pathname.startsWith('/register') || 
                       location.pathname.startsWith('/user-portal') ||
                       location.pathname.startsWith('/');

  return (
    <>
    <div className={styles.appContainer}>
      {!isPrivateApp && <Navbar />}
       {/* <Home /> */}

      
      <Routes>
 {/* <Route path="/admin" element={<MusicAdmin />} />

<Route path="/play/:id" element={<MusicViewer />} />
<Route path="/inv" element={<InvoiceGenerator />} /> */}
 <Route path="/login" element={<Login />} />
 <Route path="/register" element={<Register />} />
 <Route 
   path="/crm" 
   element={
     <AuthRoute requiredRole="crmadmin">
       <CRMApp />
     </AuthRoute>
   } 
 />
 <Route 
   path="/user-portal" 
   element={
     <AuthRoute>
       <UserPortal />
     </AuthRoute>
   } 
 />
 <Route 
   path="/" 
   element={
     <AuthRoute requiredRole="crmadmin">
       <PersonalExpenses />
     </AuthRoute>
   } 
 />
<Route path="/home" element={<Home />} />
      </Routes>
      {!isPrivateApp && <Footer/>}
    </div>
    </>
  );
};

export default App;